// Shared OneTrust constants.
// Event names dispatched on `window` when the visitor changes their consent.
export const ONETRUST_CONSENT_CHANGED = 'consent.onetrust';
export const ONETRUST_NATIVE_CONSENT_CHANGED = 'OneTrust.OnConsentChanged';

// OneTrust consent group for "Targeting Cookies" (used by YouTube embeds,
// advertising click identifiers, etc.).
export const ONETRUST_TARGETING_COOKIES_GROUP = 'C0004';
